export default __webpack_public_path__ + "static/media/list-history.6fc96833.svg";